import { makeAutoObservable } from 'mobx';

class EmptyFormState {
  question;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({question}) {
    this.question = question;

    this.question.args = {};
  }
}

export default EmptyFormState;
